module.exports = __webpack_public_path__ + "static/content-1-mobile-3560dee209e444729972f2445f494c91.png";